import React from 'react';
import RenderError from '../../components/RenderError';
import { generatorTypes, typeOfSite } from './config';

function AdditionalBasicInfoFields({
  two,
  unit,
  handleInputChange,
  equipmentType,
  formData,
  setFormData,
  errors
}) {
  return (
    <>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20 u--margin-bottom-0"
          htmlFor={`generatorType${two ? '2' : '1'}`}
        >
          What type of power generation is this?
        </label>
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError
            error={errors[`${equipmentType}_${unit}`].generatorTypes}
          />
        )}
        {generatorTypes.map((type) => (
          <label className="form__radio" key={type}>
            <input
              type="radio"
              name={`generatorType${two ? '2' : '1'}`}
              value={type}
              checked={
                two
                  ? formData.unitTwo.generatorType2 === type
                    ? 'checked'
                    : ''
                  : formData.unitOne.generatorType1 === type
                  ? 'checked'
                  : ''
              }
              onChange={(event) => handleInputChange(event, two)}
            />
            {type}
          </label>
        ))}
      </div>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20"
          htmlFor="generatorSize"
        >
          What is the generator size (kW)?
        </label>
        <input
          type="number"
          name="generatorSize"
          value={formData[unit].generatorSize}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError
            error={errors[`${equipmentType}_${unit}`].generatorSize}
          />
        )}
      </div>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20 u--margin-bottom-0"
          htmlFor={`typeOfSite${two ? '2' : '1'}`}
        >
          What type of power generation is this?
        </label>
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError error={errors[`${equipmentType}_${unit}`].typeOfSite} />
        )}
        {typeOfSite.map((type) => (
          <label className="form__radio" key={type}>
            <input
              type="radio"
              name={`typeOfSite${two ? '2' : '1'}`}
              value={type}
              checked={
                two
                  ? formData.unitTwo.typeOfSite2 === type
                    ? 'checked'
                    : ''
                  : formData.unitOne.typeOfSite1 === type
                  ? 'checked'
                  : ''
              }
              onChange={(event) => handleInputChange(event, two)}
            />
            {type}
          </label>
        ))}
      </div>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20"
          htmlFor="monthsPerYear"
        >
          How many months per year will your site require power? About how many
          hours per day?
        </label>
        <p className="u--margin-bottom-10 u--margin-top-10">
          Months per year:{' '}
        </p>
        <input
          type="number"
          name="monthsPerYear"
          value={formData[unit].monthsPerYear}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError
            error={errors[`${equipmentType}_${unit}`].monthsPerYear}
          />
        )}
        <p className="u--margin-bottom-10 u--margin-top-10">Hours per day: </p>
        <input
          type="number"
          name="hoursPerDay"
          value={formData[unit].hoursPerDay}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError error={errors[`${equipmentType}_${unit}`].hoursPerDay} />
        )}
      </div>
      <div className="form__field form__field--required">
        <label className="form__label u--margin-right-20" htmlFor="totalPower">
          How much total power, in kilowatt-hours, does the installation site
          use in a typical year? If this site previously did not require power,
          about how many kilowatt-hours do you expect the site to use in a
          typical year?
        </label>
        <input
          type="number"
          name="totalPower"
          value={formData[unit].totalPower}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError error={errors[`${equipmentType}_${unit}`].totalPower} />
        )}
      </div>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20 u--margin-bottom-0"
          htmlFor="connectedToGrid"
        >
          Is this installation site connected to the electric grid?
        </label>
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError error={errors[`${equipmentType}_${unit}`].fuelType} />
        )}
        {['Yes', 'No'].map((choice) => (
          <label className="form__radio" key={choice}>
            <input
              type="radio"
              name={`connectedToGrid${two ? '2' : '1'}`}
              value={choice}
              checked={
                two
                  ? formData.unitTwo.connectedToGrid2 === choice
                    ? 'checked'
                    : ''
                  : formData.unitOne.connectedToGrid1 === choice
                  ? 'checked'
                  : ''
              }
              onChange={(event) => handleInputChange(event, two)}
            />
            {choice}
          </label>
        ))}
      </div>
    </>
  );
}

export default AdditionalBasicInfoFields;
